export const styles = {
	topbar: 'flex items-center justify-between border-b border-subtle bg-white px-xl py-sm',
	content: 'mx-auto flex max-w-[1200px] flex-col gap-lg px-xl py-lg',
	pageEyebrow: 'text-[11px] uppercase tracking-wider text-subtle',
	pageH1: 'mt-3xs text-[20px] font-semibold text-default',
	pageSub: 'mt-3xs text-[13px] text-subtle',
	scoreCard: 'flex flex-col gap-xs rounded-md border border-subtle bg-white px-lg py-md',
	scoreLabel: 'text-[11px] uppercase tracking-wider text-subtle',
	scoreValue: 'flex items-baseline gap-xs text-[36px] font-semibold tabular-nums text-default',
	scoreSub: 'text-[12px] text-subtle',
} as const;
